import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Typography,
  Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Modal,
  Box,
  TextField,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  Tooltip
} from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
// import Option from '@mui/material/Option';
import { Helmet } from 'react-helmet-async';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar/Scrollbar';
import { Api } from '../webservices';

function Management() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [edit, setEdit] = useState(false);
  const [status, setStatus] = useState('active');
  const role = localStorage.getItem('role');
  const [editTrue, setEditTrue] = React.useState(true);
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userid');
  const [dropDownLst, setDropDownLst] = useState([])
  const id = location.state?.id

  console.log("id", id)

  useEffect(() => {
    // alert(role) 
    getCompany(id, location.state.token);
  }, [location.state]);

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [tableData, setTableData] = useState([]);
  const tableLabel = [
    // { id: 1, label: 'Company Name' },
    { id: 2, label: 'User Id' },
    { id: 4, label: 'Name' },
    { id: 3, label: 'Role' },
    { id: 5, label: 'Phone' },
    { id: 6, label: 'Email' },
    { id: 7, label: 'Password' },
    { id: 8, label: 'Action' },
  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const [formValuesAddComapnny, setFormValuesAddCompany] = useState({
    cName: '',
    role: 'recruiterHead',
    email: '',
    domain: '',
    ContactPersonName: '',
    contactNumber: '',
    password: '',
    address: '', 
    temprole: 'recruiter' 
  });

  const [loadingComp, setLoadingComp] = useState('')

  const getCompany = (id, tokenn) => {
    setLoadingComp("Loading...")
    setTableData([])
   const token = localStorage.getItem('tokenHer');
    Api(`company/get_users_list/${id}`, 'GET', '', token)
      .then((response) => {
        console.log('=========getCompany======>>>>>>>', response.data.message);
        console.log('=========getCompany======>>>>>>>', response);
        if (response.status === 200 && response.data.code === 200) {
          // toast.success(response.data.message, +'!');
          setTableData(response.data.data);
          setLoadingComp('')
        } else { 
          // toast.warn(response.data.message, +'!');
          setLoadingComp('No data found')
        }
      })
      .catch((err) => {
        console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const tablebg = 'rgba(82, 130, 190, 0.08)';

  return (
    <>
      <Helmet>
        <title> Email Management | Foxearch </title>
      </Helmet>
      <ToastContainer />

      <Stack flexDirection={'row'} alignItems={'flex-end'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} gap={1} alignItems={'center'} color={'text.secondary'}>
          <Iconify icon="ion:arrow-back" fontSize={25} sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)} />
          <Typography variant="h5" color={'text.secondary'}>
            Unverified Email Management
          </Typography>
        </Stack>
        <Stack flexDirection={'row'} gap={1} mb={1} >
          {/* <Button color="custom" variant="contained" size="small">
                  Add
                </Button> */}
        </Stack>
      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'text.secondary' }}>
              {tableLabel?.map((item) => {
                return <TableCell sx={{ p: 2, py: 0.5, color: 'white' }} key={item.id}>{item.label}</TableCell>;
              })}
            </TableRow>
          </TableHead>

          {tableData?.map((row, index) => (
            <TableBody

              key={row._id}
              sx={[
                { background: index % 2 === 0 ? 'text.background' : tablebg },
                { '&:last-child td, &:last-child th': { border: 0 } },
                { '&:hover': { boxShadow: 5 } },
              ]}
            >
              <ManagementRow data={row} />
            </TableBody>
          ))}
          {/* </TableBody> */}
          {
            loadingComp !== "" && (
              <Stack sx={{ mt: 1.5, p: 1, ml: "430px" }}>
                <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loadingComp}</Typography>
              </Stack>
            )
          }
        </Table>
      </TableContainer>

    </>
  );
}

function ManagementRow({ data, fun }) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    border: '3px solid #3C6BA5',
    borderRadius: 3,
  };
  const [formValuesAddComapnny, setFormValuesAddCompany] = useState({
    cName: '',
    role: data.role,
    email: data.email,
    domain: data.officialDomain,
    ContactPersonName: data.contactPersonName,
    contactNumber: data.contactNo,
    password: data.password,
    address: data.companyAddress,
  });
  const [edit, setEdit] = useState(false);
  const [status, setStatus] = useState('active');
  const navigate = useNavigate();
  const role = localStorage.getItem('role')
  const [accesss, setAccesss] = useState(false)
  const closeaccess = () => { setAccesss(false) }
  const openaccess = () => { setAccesss(true) }
  const [accesss1, setAccesss1] = useState(false)
  const closeaccess1 = () => { setAccesss1(false) }
  const openaccess1 = () => { setAccesss1(true) }
  const [access, setAccess] = useState({
    rworksheet: '', rdatabase: "", client: '', lead: '', jobs: '', placement: ''
  })

  const setContact = (e) => {
    const reg = /^[a-zA-Z]*$/
    if (e.length) {
      const lst = e[e.length - 1]
      if (!lst.match(reg)) {
        setFormValuesAddCompany({
          ...formValuesAddComapnny,
          contactNumber: e,
        })
      }
    } else {
      setFormValuesAddCompany({
        ...formValuesAddComapnny,
        contactNumber: e,
      })
    }

  }

  const [ModalOpen, setModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState('')
  const handleOpenModal = (id) => {
    // console.log("=============================id ", id)
    setDeleteId(id)
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCopy = () => {
    toast.success('Copied to clipboard!', {
      position: toast.POSITION.TOP_CENTER
    });
  };

  const [dropDownLst, setDropDownLst] = useState([])
  const [roleId, setRoleId] = useState('')
  const [roleParId, setRoleParId] = useState('')

  console.log("roleId", roleId)
  const [selectedValue, setSelectedValue] = useState('');
  const [roleId1, setRoleId1] = useState('')
  const [open2, setOpen2] = React.useState(false);
  const [roleDis, setRoleDis] = useState('')

  const handleOpen2 = (id, role) => {
    console.log("role", role)
    setRoleDis(role)
    setRoleId1(id)
    setOpen2(true);
  }
  const handleClose2 = () => setOpen2(false);
  const [formValuesAddComapnny1, setFormValuesAddCompany1] = useState({
    role: '',
    temprole: ''
  });

  const [showPassword, setShowPassword] = useState(true);
  const [emailCopy, setEmailCopy] = useState(false);

  const emailSendVeri = (data) => {
    const body = {
      "userId": data?._id,
      "role": data?.role
    };
    const token = localStorage.getItem("token");
    Api('email/sendSesIdentityVerificationMail', 'POST', body, token)
      .then((Response) => {
        console.log("Response", Response)
        if (Response.status === 200) {
          toast.success("Email send successfully.");
        }
        else {
          toast.warn(Response.resmessage);
        }
      });
  };

  const goto = (data) => {
    if (data.role === 'recruiterHead') {
      navigate('/unverifiedEmailRecManager', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'salesHead') {
      navigate('/unverifiedEmailSalesManager', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'recruiterManager') {
      navigate('/unverifiedEmailRecTeamLead', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'salesManager') {
      navigate('/unverifiedEmailSalesTeamLead', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'recruiterTeamLead') {
      navigate('/unverifiedEmailRec', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'salesTeamLead') {
      navigate('/unverifiedEmailSalesExective', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'recruiter') {
      navigate('/unverifiedEmailRecTrainee', { state: { id: data._id, token: data?.token } })
    } else if (data.role === 'salesExecutive') {
      navigate('/unverifiedEmailSalesTrainee', { state: { id: data._id, token: data?.token } })
    }
  }

  return (
    <>
      <TableRow key={data._id}>
        {/* <TableCell sx={{ pl: 1 }}>
        <Typography>{data.companyName}</Typography>
        </TableCell> */}
        <TableCell sx={{ pl: 1 }}>
          <Stack sx={{ flexDirection: 'row' }}>
            <Typography sx={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis' }}>{data.USERID}</Typography>
            <CopyToClipboard text={data.USERID} onCopy={handleCopy}>
              <div style={{ display: 'inline-block' }}>
                <Iconify
                  icon="radix-icons:copy"
                  color={'text.textG'}
                  sx={{ height: 17, width: 17, cursor: 'pointer', ml: 1 }}
                />
              </div>
            </CopyToClipboard>
            {/* <ToastContainer />  */}
          </Stack>
        </TableCell>

        <TableCell sx={{ pl: 2 }}>
          {edit === true ? (
            <TextField
              id="outlined-basic"
              label="Name"
              placeholder="Name"
              variant="outlined"
              value={formValuesAddComapnny.ContactPersonName}
              onChange={(e) =>
                setFormValuesAddCompany({
                  ...formValuesAddComapnny,
                  ContactPersonName: e.target.value,
                })
              }
            />
          ) : (
            // <span>{data.contactPersonName}</span>
            <span
              style={{
                cursor: 'pointer',
                fontWeight: '600',
                maxWidth: 160,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: '#3C6BA5',
              }}
            >
              {data.contactPersonName}
            </span>

          )}
        </TableCell>
        <TableCell sx={{ pl: 1 }}>
          <Typography>{data.role === 'recruiterHead' ? 'Recruitment Head' : data.role === 'recruiterManager' ? 'Recruitment Manager' : data.role === 'recruiterTeamLead' ? 'Recruitment Lead' : data.role === 'recruiter' ? 'Technical Recruiter' : data.role === 'recruiterTrainee' ? 'Recruitment Trainee' :
            data.role.replace(/([A-Z])/g, ' $&')}</Typography>
        </TableCell>

        <TableCell sx={{ pl: 2 }}>
          {edit === true ? (
            <TextField
              id="outlined-basic"
              label="Phone"
              placeholder="Phone"
              variant="outlined"
              value={formValuesAddComapnny.contactNumber}
              onChange={(e) => setContact(e.target.value)}
            // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 10, minLength: 10 }}
            />
          ) : (

            <span
              style={{
                maxWidth: 100,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {data.contactNo?.length > 12
                ? `${data.contactNo?.slice(0, 12)}...`
                : data.contactNo}
            </span>

          )}
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          {edit === true ? (
            <TextField
              id="outlined-basic"
              label="Email"
              placeholder="Email"
              variant="outlined"
              disabled
              value={formValuesAddComapnny.email}
              // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 10, minLength: 10 }}
              onChange={(e) =>
                setFormValuesAddCompany({
                  ...formValuesAddComapnny,
                  email: e.target.value,
                })
              }
            />
          ) : (
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <Typography sx={{ textTransform: 'lowercase' }}>{data.email}</Typography>

              </Box>
              <CopyToClipboard text={data.email} onCopy={() => setEmailCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={emailCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                />
              </CopyToClipboard>
            </Stack>
          )
          }
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          {edit === true ? (
            <TextField
              id="outlined-basic"
              label="Password"
              placeholder="Password"
              variant="outlined"
              value={formValuesAddComapnny.password}
              // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 10, minLength: 10 }}
              onChange={(e) =>
                setFormValuesAddCompany({
                  ...formValuesAddComapnny,
                  password: e.target.value,
                })
              }
            />
          ) : (
            // <Typography sx={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis' }}>{data.password}</Typography>

            <Stack sx={{ flexDirection: 'row', alignContent: 'center' }}>
              {showPassword ? (
                <>
                  <Typography sx={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    *****************************
                  </Typography>
                  <Iconify
                    icon="mdi:eye"
                    sx={{ color: 'text.secondary', width: 20, height: 20, mt: -0.5, ml: 0.5 }}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword(false)}
                  />
                </>
              ) : (
                <>
                  <Typography sx={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {data?.password}
                  </Typography>
                  <Iconify
                    icon="el:eye-close"
                    sx={{ color: 'text.secondary', width: 20, height: 20, ml: 1, mt: -0.2 }}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword(true)}
                  />
                </>
              )}
            </Stack>
          )}
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          <Stack flexDirection={'row'} gap={1}>
            {data?.emailIdentity === "Unverifed" ? (
              <Button color="custom" variant="contained" size="small" onClick={() => emailSendVeri(data)}>
                Unverified
              </Button>
            ) : (
              <Button color="custom" variant="contained" size="small">
                Verified
              </Button>
            )}
            {data.role !== "salesTrainee" && data.role !== "recruiterTrainee" &&
              data.role !== "benchSalesTeamLead" &&
              data.role !== "benchSalesHead" &&
              data.role !== "benchSalesManager" &&
              data.role !== "benchSalesExecutive" ?
              (
                <Iconify
                  icon="maki:arrow"
                  sx={{ color: 'text.secondary', width: 30, height: 30 }}
                  style={{ cursor: 'pointer' }}
                  onClick={() => goto(data)}
                />
              ) : null}
          </Stack>
        </TableCell>
      </TableRow>

    </>
  );
}

export default Management;
